module.exports = __webpack_public_path__ + "media/images/fr_ca/concept_leadership-2f46d7130dcd6894567434a129fde0ee.png";